import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { MaterialWithTmpFile } from '@/resources/materials/types';
import useDownloadMedia from '@/comp/use-download-media';

type Emits = {
  (e: 'upload-pdf', materialId: string): void;
  (e: 'remove-template'): void;
};
type Props = {
  material: MaterialWithTmpFile;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsMenu',
  props: {
    material: null
  },
  emits: ["upload-pdf", "remove-template"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'upload-pdf', materialId: string): void;
  (e: 'remove-template'): void;
}), expose: any, slots: any, attrs: any }) {





const { downloadMediaUrl } = useDownloadMedia();

const downloadUrl = ref('');

const onLoadMaterialDownloadUrl = (id?: string) => {
  if (!id) return;
  downloadMediaUrl(id)
    .then((url) => {
      downloadUrl.value = url;
    })
    .catch((error) => {
      console.error(error.response);
      downloadUrl.value = '';
    });
};

return { __sfc: true,emit, downloadMediaUrl, downloadUrl, onLoadMaterialDownloadUrl }
}

})